<mat-accordion class="custom-accordion box-appearance background" multi="true">
  <div class="legends-container">
    <div class="legend-group" *ngFor="let group of legendsModel?.groups || []">
      <mat-expansion-panel [expanded]="true" hideToggle>
        <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
          <mat-panel-title>
            <span class="legend-group-title">{{ group.title }}</span>
          </mat-panel-title>
          <a *ngIf="group.settingsCommandName"
             class="legend-settings-link"
             (click)="onSettings(group)">Settings</a>
        </mat-expansion-panel-header>

        <div class="contents-container">

          <ul class="legend-items">
            <li *ngFor="let item of group.items">
              <i [class]="item.icon + ' legend-icon ' + item.iconClass"></i>
              <span [innerHTML]="item.label"></span>
            </li>
          </ul>

        </div>

      </mat-expansion-panel>
    </div>
  </div>
</mat-accordion>



